/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React from 'react';
import { connect } from 'react-redux';
import {
  startSurvey, toggleSpeech, speak, openModal,
} from '../actions';
import SideBar from '../components/SideBar';

class AllSurveys extends React.Component {
  renderSurveys = () => {
    return Object.keys(this.props.surveys)
      .map((surveyid, i) => {
        const survey = this.props.surveys[surveyid];
        const key = i + 1;
        console.log(`id: ${surveyid}, name: ${survey.name}`);
        return (
          <div className="box recommended-box" key={key} style={{ marginBottom: 40 }}>
            <img src={require(`../assets/dashboard/survey-icons/survey${surveyid}.svg`)} alt="survey-icon" />
            <div className="recommended-body">
              <h2 onClick={this.props.speak} className={`${this.props.speechEnabled && 'bolded'} color`}>{survey.name}</h2>
              <p onClick={this.props.speak} className={`${this.props.speechEnabled && 'bolded'} color`}>{survey.dashboardDescription}</p>
              {this.props.inProgressSurveys.includes(surveyid) ? (
                <button
                  style={{ marginRight: 20 }}
                  type="button"
                  onClick={() => this.props.history.push(`/survey/${surveyid}`)}
                >
                  Continue
                </button>
              ) : null}
              <button
                type="button"
                className={`${survey.name !== 'How I Approach My Work' && 'disabled-button'}`}
                onClick={() => {
                  if (survey.name !== 'How I Approach My Work') {
                    this.props.openModal('MissingSurvey');
                  } else { this.props.startSurvey(surveyid, this.props.userid, this.props.history); }
                }}
              >
                {this.props.inProgressSurveys.includes(surveyid) || this.props.completedSurveys.includes(surveyid) ? 'Restart' : 'Start'}
              </button>
            </div>
          </div>
        );
      });
  }

  render() {
    return (
      <div>
        <div className="dashboard-container">
          <SideBar defaultPage="all" />
          <div className="dashboard-body-container">
            <div className="dashboard-body-subcontainer">
              <p className="all-surveys-subheader color">All Surveys</p>
              <div className="all-surveys-container">
                {this.renderSurveys()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  {
    userid: state.user.userid,
    surveys: state.survey.surveys,
    completedSurveys: state.user.completedSurveys,
    inProgressSurveys: state.user.inProgressSurveys,
    speaker: state.speech.speaker,
    speechEnabled: state.speech.enabled,
  }
);

export default connect(mapStateToProps, {
  startSurvey, toggleSpeech, speak, openModal,
})(AllSurveys);
